<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">发票管理</li>
    </ul>
    <ul class="c-list-search">
      <c_statusradiogroup
        v-model="state.params.status"
        arrName="invoiceapply_status"
        @change="onLoad"
      ></c_statusradiogroup>
      <el-select
        v-model="state.params.d_invoice_id"
        placeholder="发票类型"
        style="width: 150px"
      >
        <el-option
          v-for="item in state.invoice_data"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select
        v-model="state.params.d_invoice_type_id"
        placeholder="开票类型"
        style="width: 150px"
      >
        <el-option
          v-for="item in state.invoicetype_data"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-config-provider
        :value-on-clear="null"
        :empty-values="[undefined, null]"
      >
        <el-select
          v-model="state.params.invoice_nature"
          placeholder="发票性质"
          style="width: 150px"
        >
          <el-option label="普通发票" :value="0" />
          <el-option label="增值税发票" :value="1" />
        </el-select>
      </el-config-provider>
      <el-select
        v-model="state.params.d_invoice_kind_id"
        placeholder="开票种类"
        style="width: 150px"
      >
        <el-option
          v-for="item in state.invoicekind_data"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-date-picker
        v-model="state.dates"
        type="daterange"
        range-separator="至"
        start-placeholder="--开票日期--"
        end-placeholder="--开票日期--"
        style="flex-grow: unset"
        value-format="YYYY-MM-DD"
        @change="
          (value) => {
            if (value) state.params.invoice_date = value[0] + ' - ' + value[1];
          }
        "
        @clear="
          delete state.dates;
          delete state.params.invoice_date;
        "
      />
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column label="状态" sortable="status" width="100">
          <template #default="{ row }">
            <c_status arrName="invoice_status" :value="row.status" />
          </template>
        </el-table-column>
        <el-table-column
          prop="customer_name"
          label="客户名称"
          :formatter="$tab_TextFormat"
          min-width="180"
        />
        <el-table-column
          prop="d_invoice_name"
          label="发票类型"
          :formatter="$tab_TextFormat"
          width="120"
        />
        <el-table-column
          prop="title"
          label="发票抬头"
          :formatter="$tab_TextFormat"
          min-width="160"
        />
        <el-table-column
          prop="s_unified_social_credit_identifier"
          label="社会统一信用代码"
          :formatter="$tab_TextFormat"
          min-width="160"
        />
        <el-table-column
          prop="d_invoice_type_name"
          label="开票类型"
          :formatter="$tab_TextFormat"
          width="120"
        />
        <el-table-column prop="invoice_nature" label="开票信息" width="120">
          <template #default="{ row }">
            <text v-if="row.invoice_nature == 0">普通发票</text>
            <text style="color: #ffa500" v-else-if="row.invoice_nature == 1"
              >增值税发票</text
            >
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="d_invoice_kind_name"
          label="开票种类"
          width="120"
        />
        <el-table-column prop="contact_phone" label="联系电话" width="160" />
        <el-table-column
          prop="amount"
          label="开票金额"
          :formatter="$tab_MoneyFormat"
          min-width="160"
        />
        <el-table-column
          prop="invoice_remark"
          label="开票备注"
          :formatter="$tab_ShowToolTip"
          min-width="180"
        />
        <el-table-column
          prop="create_time"
          label="申请时间"
          :formatter="$tab_TextFormat"
          align="center"
          width="120"
        />
        <el-table-column
          prop="check_admin_name"
          label="开票人"
          min-width="120"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.check_admin_name || '-',
                row.check_department_name || ''
              )
          "
        />
        <el-table-column
          prop="check_time"
          label="开票时间"
          :formatter="$tab_TextFormat"
          align="center"
          width="120"
        />
        <el-table-column
          prop="invoice_number"
          label="发票号"
          :formatter="$tab_TextFormat"
          min-width="120"
        />
        <el-table-column
          label="操作"
          width="120"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                state.selectId = row.id;
                state.showDetail = true;
              "
              v-if="row.status == 0 && $judge_auth('144')"
            >
              操作
            </el-button>
            <el-button
              type="primary"
              link
              icon="Search"
              @click="
                state.selectId = row.id;
                state.showDetail = true;
              "
              v-else
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showDetail"
        title="开票详情"
        @close="state.showDetail = false"
      >
        <c_InvoiceDetail
          :id="state.selectId"
          @close="
            state.showDetail = false;
            onLoad();
          "
        ></c_InvoiceDetail>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  invoice_select,
  invoicetype_select,
  invoicekind_select,
} from "@/http/dictionary";
import { invoice_list } from "@/http/invoice";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    sort_field: "create_time",
    sort_value: "desc",
    name: "",
  };
}
export default {
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadInvoice();
      onLoadInvoiceType();
      onLoadInvoiceKind();
      onLoad();
    });

    //发票类型
    const onLoadInvoice = () => {
      invoice_select().then((res) => {
        if (res.status === 200) state.invoice_data = res.data.data;
      });
    };

    //开票方式
    const onLoadInvoiceType = () => {
      invoicetype_select().then((res) => {
        if (res.status === 200) state.invoicetype_data = res.data.data;
      });
    };

    //开票种类
    const onLoadInvoiceKind = () => {
      invoicekind_select().then((res) => {
        if (res.status === 200) state.invoicekind_data = res.data.data;
      });
    };

    const onLoad = () => {
      delete state.tableData;

      invoice_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      props,
      onLoad,
      onSortChange,
      onReset,
    };
  },
};
</script>
<style scoped></style>
